import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import InfiniteScroll from "react-infinite-scroll-component";
import './App.css';
import { filter } from 'lodash';
var debounce = require("lodash/debounce");

const useDebounce = (callback, delay) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  const debouncedCallback = useMemo(() => {
    const func = () => {
      ref.current?.();
    };

    return debounce(func, delay);
  }, []);

  return debouncedCallback;
};

function App() {
  const [page, setPage] = useState(1);
  const [name, setName] = useState('');
  const [instrument, setInstrument] = useState('');
  const [author, setAuthor] = useState('');

  let products = window.products;

  let filteredProducts = [...products];

  if (name) {
    filteredProducts = filteredProducts.filter(product => 
      product.name.toLowerCase().includes(name.toLowerCase())
    );
  }

  if (instrument) {
    filteredProducts = filteredProducts.filter(product => 
      product.categories.includes(instrument)
    );
  }

  if (author) {
    filteredProducts = filteredProducts.filter(product => 
      product.tags.includes(author)
    );
  }

  const itemsPerPage = 12;
  const start = 0;
  const end = page * itemsPerPage;
  
  const pagedProducts = filteredProducts.slice(start, end);

  console.log(pagedProducts);
  
  const loadMore = () => {
    setPage((prev) => {
      return prev + 1;
    });
  }

  const handleOnSearch = (e) => {
    setName(e.target.value);
    setPage(1);
  }

  const handleOnSelectInstrument = (e) => {
    setInstrument(e.target.value);
    setPage(1);
  }

  const handleOnSelectAuthor = (e) => {
    setAuthor(e.target.value);
    setPage(1);
  }

  return (
    <div>
      <div className="Search">
        <div className='SearchBar'>
          <div className='Indicator'>
            <svg width="800px" height="800px" viewBox="0 0 1024 1024" className="icon"  version="1.1" xmlns="http://www.w3.org/2000/svg">
              <path d="M448 768A320 320 0 1 0 448 128a320 320 0 0 0 0 640z m297.344-76.992l214.592 214.592-54.336 54.336-214.592-214.592a384 384 0 1 1 54.336-54.336z" />
            </svg>
          </div>
          <input onChange={handleOnSearch} value={name} type="text" placeholder="Search" className='SearchInput' />
        </div>

        <select className='SelectInput' onChange={handleOnSelectInstrument} value={instrument}>
              <option value="">Any Instrument</option>
              <option value="guitar">Guitar</option>
              <option value="bass">Bass</option>
              <option value="drums">Drum</option>
              <option value="piano-books">Piano</option>
              <option value="woodwind-brass">Woodwind & Brass</option>
              <option value="writing-music-production">Writing & Music Production</option>
              <option value="strings-books">Strings</option>
        </select>

        <select className='SelectInput' onChange={handleOnSelectAuthor} value={author}>
              <option value="">Any Author</option>
              {Object.entries(window.authors).map(([slug,name]) => (
                <option value={slug}>{name}</option>
              ))}
        </select>
      </div>

      <InfiniteScroll
        dataLength={pagedProducts.length}
        next={loadMore}
        hasMore={end < filteredProducts.length}
        loader={<div className='Loading'><h3>Loading...</h3></div>}
      >
        <div className='Products'>
          {pagedProducts.map((product) => (
            <div key={product.id} className='Product'>
              <a href={product.permalink}>
                <img src={product.image} />
              </a>

              <div className='ProductInner'>
                <div>
                  <a href={product.permalink}>
                    <h4>{product.name}</h4>
                  </a>
                  
                  {product.price && <p className='Price'>${product.price}</p>}
                </div>
                
                {product.in_stock && product.price && <div className='Buttons'>
                  {product.amazon_link && <a className='Button Button--grey' href={`${product.amazon_link}`}>
                    Buy on Amazon
                  </a>}
                  
                  {product.permalink && <a className='Button Button--orange' href={`${product.permalink}?add-to-cart=${product.id}`}>
                    Add PDF to Cart
                  </a>}
                </div>}
              </div>
            </div>
          ))}
        </div>
      </InfiniteScroll>
    </div>
  );
}

export default App;
